// import authOIDC from './auth/authOIDC';
// import authOAuth2 from './auth/authOAuth2';
import applicationReducer from './application/applicationReducer';
import dashboardReducer from './dashboard/dashboardReducer';
import categoryReducer from './categories/categoryReducer';
import adminReducer from './admin/adminReducer';

// application reducers
const reducers = {
    application: applicationReducer,
    dashboard: dashboardReducer,
    categories: categoryReducer,
    admin: adminReducer,
    // router:
    // ...authOIDC.reducer,
    // ...authOAuth2.reducer,
};

export default reducers;
